import { memo } from 'react';

const fmtEUR = (n: number | null | undefined) =>
  n == null || isNaN(n)
    ? '—'
    : n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtPct = (n: number | null) =>
  n == null
    ? '—'
    : (n >= 0 ? '+' : '') + (n * 100).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';

const marginPct = (price: number | null, mek: number | null) =>
  price == null || mek == null || mek === 0 ? null : (price - mek) / mek;

const marginClass = (m: number | null) =>
  m == null ? 'muted' : m < 0 ? 'neg' : m < 0.05 ? 'warn' : 'pos';

export const ItemPriceCell = memo(function ItemPriceCell({ price, mek }: { price: number | null; mek: number }) {
  if (price == null) return <span style={{ color: 'var(--ink-3)' }}>—</span>;

  const margin = marginPct(price, mek);
  const cls = marginClass(margin);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, width: '100%', justifyContent: 'flex-end' }}>
      <span style={{ flex: 1, textAlign: 'right' }}>{fmtEUR(price)}</span>
      <span
        className={`ds-pill ${cls}`}
        style={{ width: 40, height: 15.5, justifyContent: 'center', flexShrink: 0 }}
      >
        {fmtPct(margin)}
      </span>
    </span>
  );
});
